// @module Tavanoteam.LocationInventory.LocationInventory
define('Tavanoteam.LocationInventory.LocationInventory.View'
	, [
		'tavanoteam_locationinventory_locationinventory.tpl'

		, 'Backbone'
		, 'underscore'
	]
	, function (
		tavanoteam_locationinventory_locationinventory_tpl

		, Backbone
		, _
	) {
		'use strict';

		// @class Tavanoteam.LocationInventory.LocationInventory.View @extends Backbone.View
		return Backbone.View.extend({

			template: tavanoteam_locationinventory_locationinventory_tpl

			, initialize: function (options) {
				this.container = options.container;
				this.pdpComponent = this.container.getComponent('PDP');
				this.item = this.pdpComponent.getItemInfo().item;
				this.view = this.container.layout._currentView.attributes.id;

				var self = this;

				this.pdpComponent.on('afterOptionSelection', function (data) {
					self.getLocationInventory();

					self.render();
				});
			}

			, events: {
				'click [data-action="show-message"]': "showMessage"
			}

			, showMessage: function showMessage(event) {
				if ($('.product-line-stock-msg-out').is(':hidden')) {
					$('.product-line-stock-msg-out').show();
				} else {
					$('.product-line-stock-msg-out').hide();
				}
			}

			, getLocationInventory: function () {
				var isMatrixChildItem = this.pdpComponent.getSelectedMatrixChilds().length != 1 ? false : true,
					itemLocationInventory = isMatrixChildItem ? this.pdpComponent.getSelectedMatrixChilds()[0].quantityavailable_detail.locations : this.item.quantityavailable_detail.locations;

				var locations = [
					{
						internalid: 2,
						name: 'Anaheim, CA',
						quantity: 0
					},
					{
						internalid: 22,
						name: 'Burbank, CA',
						quantity: 0
					},
					{
						internalid: 3,
						name: 'Denver, CO',
						quantity: 0
					},
					{
						internalid: 5,
						name: 'Ontario, CA',
						quantity: 0
					},
					{
						internalid: 4,
						name: 'Salt Lake City, UT',
						quantity: 0
					},
					{
						internalid: 1,
						name: 'San Diego, CA',
						quantity: 0
					},
					{
						internalid: 6,
						name: 'San Marcos, CA',
						quantity: 0
					}]

				var locationInvetoryArray = _.map(locations, function (location) {

					_.each(itemLocationInventory, function (item) {
						if (item.internalid == location.internalid) {
							location.quantity = item.quantityavailable
						}
					});

					return location;
				});

				return locationInvetoryArray;
			}

			, getContext: function getContext() {
				var isPDP = false;
				if (this.view == "ProductDetails.Full.View") {
					isPDP = true;
				}
				var isParentItem = this.pdpComponent.getSelectedMatrixChilds().length > 1 ? true : false,
					isMatrixChildItem = this.pdpComponent.getSelectedMatrixChilds().length != 1 ? false : true,
					contextObject = {};

				if (isMatrixChildItem) {
					contextObject = {
						isParentItem: isParentItem,
						stockMessage: this.pdpComponent.getSelectedMatrixChilds()[0].isinstock ? 'In Stock' : 'On Back Order',
						stockMessageIsInStock: this.pdpComponent.getSelectedMatrixChilds()[0].isinstock,
						quantityavailable: this.pdpComponent.getSelectedMatrixChilds()[0].quantityavailable,
						showCaseQuantity: this.item.custitem_show_case_qty,
						caseQuantity: this.item.custitem_ssc_item_caseqty,
						locations: this.getLocationInventory() || [],
						backorderMessage: this.pdpComponent.getSelectedMatrixChilds()[0].outofstockmessage || SC.CONFIGURATION.TT.bkordermessage,
						isPDP: isPDP
					}
				} else {
					contextObject = {
						isParentItem: isParentItem,
						stockMessage: this.item.isinstock ? 'In Stock' : 'On Back Order',
						stockMessageIsInStock: this.item.isinstock,
						quantityavailable: this.item.quantityavailable,
						showCaseQuantity: this.item.custitem_show_case_qty,
						caseQuantity: this.item.custitem_ssc_item_caseqty,
						locations: this.getLocationInventory() || [],
						backorderMessage: this.item.outofstockmessage || SC.CONFIGURATION.TT.bkordermessage,
						isPDP: isPDP
					}
				}

				return contextObject;
			}
		});
	});
